function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPositive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "sfh6ecsoka"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 215",
    style: {
      fill: "#e63d44"
    },
    d: "M0 0h16v16H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 3",
    style: {
      clipPath: "url(#sfh6ecsoka)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 2",
    d: "M8 0a8 8 0 1 0 8 8 8 8 0 0 0-8-8M3.686 6.261A1.219 1.219 0 1 1 4.905 7.48a1.219 1.219 0 0 1-1.219-1.219m4.327 6.6a3.216 3.216 0 0 1-3.287-3.14H11.3a3.216 3.216 0 0 1-3.287 3.14m3.082-5.381a1.219 1.219 0 1 1 1.219-1.219 1.219 1.219 0 0 1-1.219 1.219",
    style: {
      fill: "#e63d44"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPositive);
export default __webpack_public_path__ + "static/media/icon-positive.d87d964179fe64e28d6e96f223d2ceb9.svg";
export { ForwardRef as ReactComponent };